import { DateRange, DayPicker, Matcher } from "react-day-picker";

interface CustomDateRangePickerBodyProps {
  selectedRange?: DateRange | undefined;
  setSelectedRange?: React.Dispatch<
    React.SetStateAction<DateRange | undefined>
  >;
  setDateRange?: React.Dispatch<React.SetStateAction<DateRange | undefined>>;
  disabledDate?: Matcher;
}

export function CustomDateRangePickerBody({
  selectedRange,
  setDateRange,
  setSelectedRange,
  disabledDate,
}: CustomDateRangePickerBodyProps) {
  return (
    <DayPicker
      mode="range"
      selected={selectedRange}
      onSelect={(range) => {
        setSelectedRange?.(range);
        setDateRange?.(range);
      }}
      classNames={{
        day_button: "text-sm font-semibold rounded-full w-8 h-6",
        day: "text-sm hover:bg-gray-300 hover:rounded-md",
        disabled: "hover:bg-transparent text-gray-400",
        selected: "bg-blue-100 text-blue-500",
        outside: "text-gray-300",
        range_start: "bg-blue-100 text-blue-500",
        range_end: "bg-blue-100 text-blue-500 rounded-r-md",
      }}
      disabled={disabledDate}
      components={{
        Chevron: ({ orientation }) => {
          return {
            left: (
              <i className="ki-filled ki-left text-xl font-bold text-blue-500" />
            ),
            right: (
              <i className="ki-filled ki-right text-xl font-bold text-blue-500" />
            ),
            down: (
              <i className="ki-filled ki-down text-xl font-bold text-blue-500" />
            ),
            up: (
              <i className="ki-filled ki-up text-xl font-bold text-blue-500" />
            ),
          }[orientation ?? "right"];
        },
      }}
    />
  );
}
